import { createSaga } from './saga-helpers';

import * as Api from '../api/messages-api';

const watchGetMessages = createSaga({
    type: 'MESSAGES_FETCH',
    fn: Api.fetchMessages,
    args: action => [action.payload],
    successPayload: (messages, action) => ({
        ...messages,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        ...action.payload
    })
});

const watchSendMessage = createSaga({
    type: 'MESSAGE_SEND',
    fn: Api.sendMessage,
    args: action => [action.payload.message],
    successPayload: (message, action) => ({
        message,
        fragment: action.payload.message
    }),
    errorPayload: (e, action) => ({
        fragment: action.payload.message
    }),
    progressPayload: (progress, action) => ({ files: action.payload.message?.files?.map(({ name }) => ({ name })), progress }),
    progress: true
});

const watchGetMessage = createSaga({
    type: 'MESSAGE_FETCH',
    fn: Api.fetchMessage,
    args: action => [action.payload.messageId],
    successPayload: (message, action) => ({
        messageId: action.payload.messageId,
        message
    }),
    errorPayload: (e, action) => ({
        messageId: action.payload.messageId
    })
});

const watchUpdateMessage = createSaga({
    type: 'MESSAGE_UPDATE',
    fn: Api.updateMessage,
    args: action => [action.payload.messageId, action.payload.messageProps]
});

const watchRemoveMessage = createSaga({
    type: 'MESSAGE_REMOVE',
    fn: Api.removeMessage,
    args: action => [action.payload.messageId]
});

const watchSeeMessage = createSaga({
    type: 'MESSAGE_SEE',
    fn: Api.seeMessage,
    args: action => [action.payload.messageId],
    successPayload: ({ message_ids: messageIds }, action) => ({
        messageIds,
        userId: action.payload.userId
    })
});

const watchSeeMessages = createSaga({
    type: 'MESSAGES_SEE',
    fn: Api.seeMessages,
    args: action => [action.payload.messages],
    successPayload: ({ message_ids: messageIds }, action) => ({
        messageIds,
        userId: action.payload.userId
    })
});

const watchHearMessage = createSaga({
    type: 'MESSAGE_HEAR',
    fn: Api.hearMessage,
    args: action => [action.payload.messageId],
    successPayload: ({ message_ids: messageIds }, action) => ({
        messageIds,
        userId: action.payload.userId
    })
});

const watchSetMessageReaction = createSaga({
    type: 'MESSAGE_SET_REACTION',
    fn: Api.setMessageReaction,
    args: action => [action.payload.messageId, action.payload.reaction]
});

const sagas = [watchGetMessages, watchSendMessage, watchGetMessage, watchUpdateMessage, watchRemoveMessage, watchSeeMessage, watchSeeMessages, watchHearMessage, watchSetMessageReaction];

export default sagas;
